import { render, staticRenderFns } from "./ArrowDiscount.vue?vue&type=template&id=f42ea6b8&"
import script from "./ArrowDiscount.vue?vue&type=script&lang=js&"
export * from "./ArrowDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports